import { createFileRoute } from '@tanstack/react-router';

import { AssessmentCreateScreen } from '@/features/assessments/components/workspace/AssessmentCreateScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/assessments/new')({
  beforeLoad: () => {
    requirePermission('assessment:create');
  },
  component: AssessmentCreateScreen,
  staticData: { crumb: 'New' },
});
